import { MessageSystem } from '@halo/ui-chat-react';
import { MsgItem } from '../../msg-parts';
import type { MsgGroupUpdateDescriptionContentProps } from './msg-group-update-description-content';
import { MsgGroupUpdateDescriptionContent } from './msg-group-update-description-content';

export interface MsgGroupUpdateDescriptionProps extends MsgGroupUpdateDescriptionContentProps {}

export const MsgGroupUpdateDescription = memo(function MsgGroupUpdateDescription({
  message,
}: MsgGroupUpdateDescriptionProps) {
  return (
    <MsgItem message={message}>
      <MessageSystem>
        <MsgGroupUpdateDescriptionContent message={message} />
      </MessageSystem>
    </MsgItem>
  );
});
